"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

var BasicApi =
/*#__PURE__*/
function () {
  function BasicApi(_ref) {
    var userTokenFactory = _ref.userTokenFactory,
        accountIdFactory = _ref.accountIdFactory;
    (0, _classCallCheck2.default)(this, BasicApi);
    this.userTokenFactory = userTokenFactory;
    this._accountIdFactory = accountIdFactory;
  } // TODO: remove this method


  (0, _createClass2.default)(BasicApi, [{
    key: "getHeaders",
    value: function () {
      var _getHeaders = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(token) {
        var userToken;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userToken = token || this.userToken;
                return _context.abrupt("return", {
                  headers: {
                    Authorization: userToken,
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getHeaders(_x) {
        return _getHeaders.apply(this, arguments);
      }

      return getHeaders;
    }()
  }, {
    key: "headers",
    get: function get() {
      return {
        headers: {
          Authorization: this.userToken
        }
      };
    }
  }, {
    key: "userToken",
    get: function get() {
      return this.userTokenFactory();
    }
  }, {
    key: "accountIdFactory",
    get: function get() {
      if (_lodash.default.isFunction(this._accountIdFactory)) return this._accountIdFactory();
      return 'unset';
    }
  }]);
  return BasicApi;
}();

var _default = BasicApi;
exports.default = _default;